import React, { Component } from 'react';
import Layout from '../../Layout';
import SearchSubHeader from './SearchSubheader';
import AdvancedSearchForm from '../AdvancedSearch/AdvancedSearchForm';
import Loader from './Loader';
import ResultsTable from './ResultsTable';
import SimpleInput from '../SimpleSearch/SimpleInput';
import { getAdvanced, getSimple } from '../actions';
import { groupBy } from '../dataTransform';

class SearchFormCommon extends Component {

  constructor(props) {
    super(props);
    this.state = {
      lemaData: [],
      count: 0,
      form_count: 0,
      loading: false,
      firstRequestDone: false,
      page: 1,
      sort: '-freq',
      expanded: [],
      request: {
        mwe: '',
        exact: false,
        coll: {
          sr: 'nesvarbu',
          wc: '0',
          freq: '0',
        },
        w1: {
          word: '',
          lema: false,
          exact: false,
          pos: 'nesvarbu',
          w1: false,
          w2: false,
          w3: false,
          main: false,
        },
        w2: {
          word: '',
          lema: false,
          exact: false,
          pos: 'nesvarbu',
          w1: false,
          w2: false,
          w3: false,
          main: false,
        },
        w3: {
          word: '',
          lema: false,
          exact: false,
          pos: 'nesvarbu',
          w1: false,
          w2: false,
          w3: false,
          main: false,
        },
      },
    };
    this.handleData = this.handleData.bind(this);
    this.handleSimpleSetState = this.handleSimpleSetState.bind(this);
    this.handlePagination = this.handlePagination.bind(this);
    this.clearLemaData = this.clearLemaData.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.saveRequest = this.saveRequest.bind(this);
    this.handleOnExpand = this.handleOnExpand.bind(this);
  }

  handleGetRequest() {
    this.handleSimpleSetState('loading', true);
    this.clearLemaData();
    const getRequest = this.props.type === 'simple'
      ? getSimple(this.state.request.mwe, this.state.request.exact, this.state.page, this.state.sort)
      : getAdvanced(this.state.request.coll, this.state.request.w1, this.state.request.w2,
        this.state.request.w3, this.state.page, this.state.sort);

    getRequest
      .then(response => {
        let groupedData = groupBy(response.data.mwe);
        this.handleData(groupedData, response.data.count, response.data.form_count);
      })
      .catch(error => {
        console.log(error);
      })
      .then(() => {
        this.handleSimpleSetState('loading', false);
        this.scrollTableIntoView();
      });
  }

  scrollTableIntoView() {
    const searchButton = document.querySelector('.search-button');

    window.scrollTo(0, (searchButton && searchButton.offsetTop) || 0);
  }

  saveRequest = (data) => {
    if (this.props.type === 'simple') {
      this.setState({
        request: {
          mwe: data.mwe,
          exact: data.exact,
        },
      });
    } else {
      this.setState({
        request: {
          coll: {
            ...data.coll,
          },
          w1: {
            ...data.w1,
          },
          w2: {
            ...data.w2,
          },
          w3: {
            ...data.w3,
          },
        },
      });
    }
  };

  handleSimpleSetState = (name, value) => {
    this.setState({ [name]: value });
  };

  handlePagination(page) {
    this.setState({ page: page }, () => this.handleGetRequest());
  }

  handleSort(sortField, sortOrder) {
    const sort = sortOrder === 'desc' ? `-${sortField}` : sortField;
    this.setState({ sort: sort }, () => this.handleGetRequest());
  }

  handleData = (data, count, form_count) => {
    this.setState({
      lemaData: [...data],
      count: count,
      form_count: form_count,
    });
  };

  clearLemaData() {
    this.setState({
      lemaData: [],
      count: 0,
      form_count: 0,
      expanded: [],
    });
  }

  handleOnExpand = (row, isExpand, rowIndex, e) => {
    if (isExpand) {
      this.setState(() => ({
        expanded: [...this.state.expanded, row.lema]
      }));
    } else {
      this.setState(() => ({
        expanded: this.state.expanded.filter(x => x !== row.lema)
      }));
    }
  };


  render() {
    return (
      <Layout className="home">
        <SearchSubHeader/>

        {
          this.props.type === 'simple' &&
          <SimpleInput lemaData={this.state.lemaData} onLemaAdded={this.handleData}
                       saveRequest={this.saveRequest}
                       clearLemaData={this.clearLemaData}
                       sort={this.state.sort}
                       handleSimpleSetState={this.handleSimpleSetState}
          />
        }
        {
          this.props.type === 'advanced' &&
          <AdvancedSearchForm
            lemaData={this.state.lemaData} onLemaAdded={this.handleData}
            saveRequest={this.saveRequest}
            clearLemaData={this.clearLemaData}
            sort={this.state.sort}
            handleSimpleSetState={this.handleSimpleSetState}
          />
        }

        {
          this.state.loading &&
          <div className="text-center">
            <Loader/>
          </div>
        }
        {
          this.state.firstRequestDone &&
          <ResultsTable
            lemaData={this.state.lemaData} count={this.state.count}
            formCount={this.state.form_count} page={this.state.page}
            handleTableChange={this.handlePagination} loading={this.state.loading}
            handleSort={this.handleSort}
            expanded={this.state.expanded} handleOnExpand={this.handleOnExpand}
          />
        }
      </Layout>
    );
  }
}

export default SearchFormCommon;
